import styles from './ConnectSalesforceForm.module.scss';
import { salesforceFieldsDescriptions } from '../../../constants/salesforceWarehouseFieldDescription';
import { InfoTooltip } from '../../common/InfoTooltip';
import SimpleInput from '../../common/SimpleInput';
import React, { useMemo, useState } from 'react';
import PasswordInput from '../../common/PasswordInput';
import { Note } from '../../common/Note';
import Button from '../../common/Button';
import { merge } from 'lodash';
import { useSelector } from 'react-redux';
import history from '../../../utils/history';

export const SalesforceFormTypes = {
  EDIT: 'EDIT',
  ADD: 'ADD',
};

export function SalesforceWarehouseForm(props) {
  const { formType, onSubmit, warehouse } = props;
  const connectionData = warehouse?.orders_integration_data?.connection_data;
  const { submitting } = useSelector((state) => state.warehouses);
  const [authData, setAuthData] = useState({
    client_id: connectionData?.auth?.client_id || '',
    client_password: connectionData?.auth?.client_password || '',
    client_secret: connectionData?.auth?.client_secret || '',
  });
  const [apiData, setApiData] = useState({
    short_code: connectionData?.api?.short_code || '',
    tenant: connectionData?.api?.tenant || '',
    site_id: connectionData?.api?.site_id || '',
    organization_id: connectionData?.api?.organization_id || '',
  });

  const isDisabled = useMemo(() => {
    const emptyValues = Object.values(merge({}, apiData, authData)).filter((value) => !value?.length);
    return !!emptyValues.length;
  }, [apiData, authData]);

  const backToWarehousesPage = (e) => {
    history.push(`/suppliers/${warehouse.supplier_id}/admin/warehouses`);
  };

  const submit = (e) => {
    const connectionData = { api: apiData, auth: authData };
    onSubmit(connectionData);
    e.preventDefault();
  };
  const renderInput = (fieldDescription) => {
    const { key, title, content, path } = fieldDescription;
    return (
      <div key={key} className={styles.fieldContainer}>
        <label>
          {title}
          <span className={styles.mandatory}>*</span>
          <InfoTooltip width={520} content={content} />
        </label>
        {path === 'api' ? (
          <div className={styles.simpleInputContainer}>
            <SimpleInput
              className={styles.salesforceInput}
              value={apiData[key]}
              onChange={(e) => {
                setApiData((prevState) => ({ ...prevState, [key]: e.target.value }));
              }}
            />
          </div>
        ) : (
          <PasswordInput
            value={authData[key]}
            disabled={formType === SalesforceFormTypes.EDIT}
            onChange={(e) => {
              setAuthData((prevState) => ({ ...prevState, [key]: e.target.value }));
            }}
          />
        )}
      </div>
    );
  };

  return (
    <form className={styles.form} onSubmit={submit}>
      <div className={styles.body}>
        {salesforceFieldsDescriptions.map((fieldDescription) => renderInput(fieldDescription))}
        <Note>
          <strong>NOTE:</strong> You can find the Connection Guidelines on{' '}
          <a target="_blank" href="https://www.cym.bio/salesforce-integration/" rel="noreferrer">
            Cymbio Website
          </a>{' '}
          .
        </Note>
      </div>

      <div className={styles.footer}>
        {formType === SalesforceFormTypes.EDIT && (
          <Button type="button" text="Cancel" loading={submitting} onClick={backToWarehousesPage} color="white" />
        )}
        <Button type="submit" text="Save" loading={submitting} disabled={isDisabled || submitting} />
      </div>
    </form>
  );
}
